import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    creditUtilisationLimitMessage: {
        id: '_.dashboard.approved.credit_utilisation_limit_message',
        defaultMessage: `Valid until {date}`
    },
    creditUtilisationExpiredApprovalMessage: {
        id: '_.dashboard.approved.credit_utilisation_expired_approval_message',
        defaultMessage: 'Refresh required'
    }
});
